export const CLOSE_WIDGET = 'CLOSE_WIDGET'
